import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Check, X, Printer } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Belge } from "@/components/teklif/TeklifBelge";
import api, { errMsg } from "@/lib/api";

const DURUM = { yeni: "Onayınızı bekliyor", onaylandi: "Onaylandı", reddedildi: "Reddedildi" };

export default function TeklifOnay() {
  const { token } = useParams();
  const [t, setT] = useState(null);
  const [hata, setHata] = useState("");
  const [ad, setAd] = useState("");
  const [not, setNot] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/acik/teklif/${token}`).then((r) => setT(r.data)).catch((e) => setHata(errMsg(e))); }, [token]);
  const karar = async (k) => {
    if (ad.trim().length < 2) { setHata("Lütfen adınızı ve soyadınızı yazın"); return; }
    if (!window.confirm(k === "onayla" ? "Teklifi onaylıyor musunuz?" : "Teklifi reddetmek istiyor musunuz?")) return;
    setBusy(true); setHata("");
    try { setT((await api.post(`/acik/teklif/${token}/karar`, { karar: k, ad, not })).data); } catch (e) { setHata(errMsg(e)); } finally { setBusy(false); }
  };
  if (!t) return <div className="min-h-screen bg-neutral-100 flex items-center justify-center p-6 text-sm text-neutral-600" data-testid="teklif-onay-hata">{hata || "Yükleniyor…"}</div>;
  const acik = t.durum === "yeni" && !t.suresi_doldu;
  return (
    <div className="min-h-screen bg-neutral-100 py-8 px-3" data-testid="teklif-onay-sayfa">
      <div className="max-w-3xl mx-auto space-y-4">
        <div className="rounded-xl bg-white p-4 text-sm text-neutral-800 flex flex-wrap items-center gap-2" data-testid="teklif-onay-durum">
          <span className="font-semibold">{t.no}</span><span className="text-neutral-500">·</span>
          <span>{t.suresi_doldu ? "Geçerlilik süresi doldu" : DURUM[t.durum] || t.durum}</span>
          {t.onay?.kullanici && <span className="text-neutral-500">({t.onay.kullanici} · {new Date(t.onay.tarih).toLocaleString("tr-TR")})</span>}
          <button data-testid="teklif-onay-yazdir" onClick={() => window.print()} className="ml-auto inline-flex items-center gap-1.5 px-3 h-9 rounded-lg bg-neutral-200 hover:bg-neutral-300 text-neutral-900"><Printer className="w-4 h-4" />Yazdır / PDF</button>
        </div>
        <Belge t={t} cari={t.cari || {}} />
        {acik && <div className="rounded-xl bg-white p-5 space-y-3 text-neutral-900" data-testid="teklif-onay-form">
          <div className="font-semibold">Teklif kararınız</div>
          <Input data-testid="teklif-onay-ad" placeholder="Adınız soyadınız *" value={ad} onChange={(e) => setAd(e.target.value)} className="bg-white border-neutral-300 text-neutral-900" />
          <Input data-testid="teklif-onay-not" placeholder="Not (isteğe bağlı)" value={not} onChange={(e) => setNot(e.target.value)} className="bg-white border-neutral-300 text-neutral-900" />
          {hata && <div className="text-sm text-red-600" data-testid="teklif-onay-mesaj">{hata}</div>}
          <div className="flex flex-wrap gap-2">
            <button data-testid="teklif-onay-onayla" disabled={busy} onClick={() => karar("onayla")} className="inline-flex items-center gap-1.5 px-5 h-11 rounded-lg font-semibold bg-emerald-600 hover:bg-emerald-500 text-white disabled:opacity-50"><Check className="w-4 h-4" />Onaylıyorum</button>
            <button data-testid="teklif-onay-reddet" disabled={busy} onClick={() => karar("reddet")} className="inline-flex items-center gap-1.5 px-5 h-11 rounded-lg font-semibold bg-neutral-200 hover:bg-neutral-300 text-neutral-900 disabled:opacity-50"><X className="w-4 h-4" />Reddet</button>
          </div>
        </div>}
      </div>
    </div>
  );
}
